export const hooks = {
  'Code validated successfully!': 'Código validado exitosamente!',
  'Error, something unexpected happened': 'Error, algo inesperado se pasió',
  'Invalid code!': 'Código inválido!',
};
